import Service from './abstract';

class NotificationsService extends Service {
    constructor () {
        super('notifications');
    }

    getNotifications (params = {}) {
        const defaultParams = {
            with: 'notification_recipient',
            filters: 'id_notification_category eq 1',
            order: 'id-desc',
            ...params
        };

        return this.get({
            url: `${this.basePath}/notifications/custom/template`,
            qs: defaultParams
        });
    }

    getCategories () {
        return this.get({
            url: `${this.basePath}/notifications/categories`,
        });
    }

    getRecipients () {
        return this.get({
            url: `${this.basePath}/recipients`,
        });
    }

    createCustomNotification (data) {
        return this.post({
            url: `${this.basePath}/notifications/custom/template`,
            data
        });
    }

    getNotificationById (id) {
        return this.get({
            url: `${this.basePath}/notifications/custom/template/${id}`,
        });
    }

    updateCustomNotification (id, data) {
        return this.put({
            url: `${this.basePath}/notifications/custom/template/${id}`,
            data
        });
    }

    deleteCustomNotification (id) {
        return this.delete({
            url: `${this.basePath}/notifications/custom/template/${id}`,
        });
    }
}

export default new NotificationsService();
